// Links people share from Jammable carry their own referral code, so every
// cover, voice page or profile a code owner posts can earn them 20%
// (lib/referral/commission) without their thinking about it. Browser only:
// the code comes from the signed-in user AuthProvider keeps in localStorage,
// the link style from the one picked on /earn (components/referral/
// useLinkStyle). Without a code, or off the browser, links are untouched.
import {
  LINK_PARAMS,
  LINK_STYLES,
  normalizeReferralCode,
  type LinkStyle,
} from "./code";

export const LINK_STYLE_KEY = "jam_link_style";

export function myReferralCode(): string | null {
  if (typeof window === "undefined") return null;
  try {
    const user = JSON.parse(localStorage.getItem("user") || "null");
    return normalizeReferralCode(user?.referralCode);
  } catch {
    return null;
  }
}

function myLinkStyle(): LinkStyle {
  try {
    const saved = localStorage.getItem(LINK_STYLE_KEY) as LinkStyle | null;
    return saved && LINK_STYLES.includes(saved) ? saved : "ref";
  } catch {
    return "ref";
  }
}

// The url with the sharer's code on it, replacing whoever's code it carried
// (someone sharing a page they arrived at through another creator's link).
export function withMyReferral(url: string): string {
  const code = myReferralCode();
  if (!code) return url;
  try {
    const u = new URL(url, window.location.origin);
    for (const p of LINK_PARAMS) u.searchParams.delete(p);
    u.searchParams.set(myLinkStyle(), code);
    return u.toString();
  } catch {
    return url;
  }
}
